import { DateUtils, EErrorLevel, logger } from '@web_opxp/features';
import findLast from 'lodash/findLast';
import orderBy from 'lodash/orderBy';
import { getTrainingConfig } from '../cycles/utils';

const orderByFromDay = <T extends { from_day: number }>(data: Array<T>) => orderBy(data, 'from_day', 'desc');

export const startNextAssessmentPossible = (
  created: number,
  lastResultTimestamp: number,
  assessmentRepeatConfig?: Array<{ from_day: number; assessment_repet_days: number }>
) => {
  if (!assessmentRepeatConfig || assessmentRepeatConfig.length < 1) {
    logger('assessment repeat config empty!', EErrorLevel.Warning);
    return true;
  }
  const now = DateUtils.getUnixTimestamp();
  const daysFromCreation = (now - created) / (60 * 60 * 24);
  const sortedConfig = orderByFromDay(assessmentRepeatConfig);
  let matchingConfig;
  for (const repeatConfig of sortedConfig) {
    if (daysFromCreation >= repeatConfig.from_day) {
      matchingConfig = repeatConfig;
      break;
    }
  }
  if (!matchingConfig) {
    logger('no matching config found!', EErrorLevel.Warning);
    return true;
  }
  if (!lastResultTimestamp) {
    return true;
  }
  const daysFromLastAssessment = (now - lastResultTimestamp) / (60 * 60 * 24);
  if (matchingConfig.assessment_repet_days > daysFromLastAssessment) {
    return false;
  }
  return true;
};

export const getQuestionaireConfig = () => {
  const trainingConfig = getTrainingConfig();
  if (!trainingConfig) {
    throw new Error('Training configuration is unavailable!');
  }
  return trainingConfig.questionaire_config;
};

export const getQuestionaireConfigForCycle = (cycleId: number) => {
  const configs = getQuestionaireConfig();
  if (!configs) {
    return null;
  }
  const configForCycle = findLast(configs, (config) => {
    return config.from_cycle_id <= cycleId;
  });
  if (!configForCycle) {
    return null;
  }
  return configForCycle;
};
